
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {
  "title": "Here is the toolkit to develop your House Marketplace",
  "date": "2021-09-20"
};
const slug = 'house-marketplace-app';
const tableOfContents = [{
  "title": "House Marketplace",
  "slug": "house-marketplace",
  "children": []
}, {
  "title": "",
  "slug": "",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><em parentName="p">{`Looking to build a`}</em>{` House marketplace `}<em parentName="p">{`and apps?`}</em>{` Here is the toolkit that lets you build & launch any marketplace without writing a line of code.`}</p>
    <p><a parentName="p" {...{
        "href": "https://tradly.app/"
      }}>{`Tradly Platform`}</a>{` has a simple UI to build any marketplace like `}<strong parentName="p"><em parentName="strong">{`House marketplace`}</em></strong>{` and can be controlled every function in the SuperAdmin panel (dashboard). `}<em parentName="p">{`It is a complete white label solution…`}</em></p>
    <p>{`The marketplace can be built on any platform, whether it is Android or iOS. Along with this option, you also get a web app template to get started.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`Here is an example of how you can configure the catalog, listing fields in your marketplace…`}</em></strong></p>
    <_Heading level={2} id={"house-marketplace"} nextElement={{
      "type": "paragraph"
    }}>House Marketplace</_Heading>
    <p>{`Each house is different from the other in terms so of architecture, look, and build. This is also because each serves a different aspect in accordance with the demographics, climate, and the way locals live in that particular area.`}</p>
    <p><a parentName="p" {...{
        "href": "https://dribbble.com/shots/16089155-Property-Marketplace-Mobile"
      }}><img parentName="a" {...{
          "src": "images/0f88e23254a18b2684d9382ffb36dab3-1.jpg",
          "alt": null
        }}></img></a></p>
    <_Heading level={2} id={""} nextElement={{
      "type": "table",
      "align": [null]
    }}></_Heading>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Names`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bungalows`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apartments and Flats`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Penthouses`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Studio Flats`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Villas`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Housing Complexes / Societies`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Farmhouses / Second homes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Huts`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eco-friendly Homes`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
